/**
 * @readonly
 * @const { object }
 * @desc This object is type constant for the menu management.
 */
export const Type = Object.freeze({
	Tab: 'tab',
	Subtab: 'subtab',
	Role: 'role',
	Tabs: 'tabs',
	Subtabs: 'subtabs',
	Roles: 'roles',
	Continue: true,
	Reset: false,
	All: 'all',
});

/**
 * @readonly
 * @const { object }
 * @desc This object is the group's constant for the role group.
 */
export const Group = Object.freeze({
	Id: 'id',
	Name: 'name',
	Desc: 'desc',
	Tabs: 'tabs',
	Roles: 'roles',
});

/**
 * @readonly
 * @const { object }
 * @desc This object is the Tab's constant for the Cantabs v3.
 */
export const Tab = Object.freeze({
	GroupId: 'groupId',
	Id: 'id',
	Name: 'name',
	Url: 'url',
	Desc: 'desc',
	Order: 'order',
	Checked: 'checked',
	Subtabs: 'subtabs',
	SubtabId: 'subtabId',
	Open: 'open',
});

/**
 * @readonly
 * @const { object }
 * @desc This object is the role's constant for the roles.
 */
export const Role = Object.freeze({
	GroupId: 'groupId',
	Id: 'id',
	Name: 'name',
	Desc: 'desc',
	Type: 'type',
	Checked: 'checked',
});
